import { render, staticRenderFns } from "./ServicePrices2.vue?vue&type=template&id=51acb3f5&"
import script from "./ServicePrices2.vue?vue&type=script&lang=js&"
export * from "./ServicePrices2.vue?vue&type=script&lang=js&"
import style0 from "./ServicePrices2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports